import axios from "axios";
import { NGROK } from "./APIs";
import useCloudSyncStore from "./services/useCloudSyncStore";

const isBackgroundSyncResponse = (status) =>
  status === 409 || status === 504 || status === 502 || status === 503;

export const triggerCloudSync = async (cloud, endpoint, tenantName, onComplete) => {
  const {
    syncStatus,
    setSyncStatus,
    startSyncPolling,
    clearSyncTracking,
    resumeSyncPollingIfNeeded,
    registerSyncCallback,
  } = useCloudSyncStore.getState();

  if (syncStatus[cloud]) {
    if (typeof onComplete === "function") {
      registerSyncCallback(cloud, onComplete);
    }
    resumeSyncPollingIfNeeded(cloud, tenantName, onComplete);
    return {
      message: "Sync already in progress",
      alreadyRunning: true,
    };
  }

  setSyncStatus(cloud, true);

  try {
    const response = await axios.get(`${NGROK}${endpoint}`, {
      params: { tenantName },
      validateStatus: (status) =>
        (status >= 200 && status < 300) || isBackgroundSyncResponse(status),
    });

    if (response.status === 409) {
      startSyncPolling(cloud, tenantName, onComplete);
      return {
        message: response.data?.message || "Sync already in progress",
        alreadyRunning: true,
        started: true,
      };
    }

    if (response.status === 504) {
      startSyncPolling(cloud, tenantName, onComplete);
      return {
        message: "Sync is running in the background. This may take several minutes.",
        timedOut: true,
        started: true,
      };
    }

    startSyncPolling(cloud, tenantName, onComplete);
    return {
      ...(response.data || {}),
      started: true,
    };
  } catch (error) {
    const status = error.response?.status;

    if (isBackgroundSyncResponse(status)) {
      startSyncPolling(cloud, tenantName, onComplete);
      return {
        message: "Sync is running in the background. This may take several minutes.",
        timedOut: true,
        started: true,
      };
    }

    if (status === 409) {
      startSyncPolling(cloud, tenantName, onComplete);
      return {
        message: error.response?.data?.message || "Sync already in progress",
        alreadyRunning: true,
        started: true,
      };
    }

    clearSyncTracking(cloud);
    console.error(`Error syncing ${cloud.toUpperCase()}:`, error);
    throw error;
  }
};

export const triggerAwsOnDemand = async (tenantName, onComplete) => {
  return triggerCloudSync("aws", "/api/aws/ondemand", tenantName, onComplete);
};
